import React from 'react';
import PropTypes from 'prop-types';
import { ApolloProvider } from 'react-apollo';
import { withAuth } from '@okta/okta-react';
import getClientSwitch from '../../apollo-client';

export const ApolloProviderWrapperComponent = ({ children, auth }) => (
  <ApolloProvider client={getClientSwitch()(auth)}>
    {children}
  </ApolloProvider>
);

ApolloProviderWrapperComponent.propTypes = {
  children: PropTypes.node.isRequired,
  auth: PropTypes.object,
};

export default withAuth(ApolloProviderWrapperComponent);



// WEBPACK FOOTER //
// ./src/app/containers/ApolloProviderWrapper/index.js